import { useEffect, useState } from "react";
import { Loader2, Timer } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { formatDate } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const INPUT_DARK = "border-white/15 bg-white/5 text-white placeholder:text-slate-500 focus-visible:ring-[#00D1A8]/50 [color-scheme:dark]";

export const PromoSettings = () => {
  const [promo, setPromo] = useState(null);
  const [date, setDate] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/promo").then((r) => {
      setPromo(r.data);
      setDate(r.data.ends_at);
    }).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/admin/promo", { ends_at: date });
      setPromo(data);
      toast.success(data.active ? `Promo aktif hingga ${formatDate(data.ends_at)}` : "Promo berakhir — harga normal berlaku");
    } catch (e) {
      toast.error(apiError(e, "Gagal menyimpan promo"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="relative mt-6 flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-white/10 bg-white/[0.04] p-5 backdrop-blur-md" data-testid="promo-settings">
      <div>
        <p className="flex items-center gap-2 text-sm font-semibold text-white"><Timer className="h-4 w-4 text-[#00D1A8]" /> Promo Harga di Landing Page</p>
        <p className="mt-1 text-xs text-slate-400">
          {promo === null ? "Memuat…" : promo.active
            ? <>Harga promo & hitung mundur tampil sampai <span className="font-semibold text-[#00D1A8]" data-testid="promo-status">{formatDate(promo.ends_at)}</span> (23:59 WIB), lalu otomatis kembali ke harga normal.</>
            : <span className="font-semibold text-amber-400" data-testid="promo-status">Promo berakhir — landing page menampilkan harga normal.</span>}
        </p>
      </div>
      <div className="flex items-center gap-2">
        <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className={`${INPUT_DARK} w-44`} data-testid="promo-date-input" />
        <Button onClick={save} disabled={saving || !date} className="bg-gradient-to-r from-[#2563EB] to-[#00D1A8] font-semibold text-white hover:opacity-95" data-testid="promo-save-btn">
          {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Simpan
        </Button>
      </div>
    </div>
  );
};
